export default {
  workingSiteRemoved: 'Working site removed',
  workingSiteUpdated: 'Working site updated',
  workingSiteAdded: 'Working site added',
  workingSites: 'Working sites',
  workingSite: 'Working site',
  workingSiteId: 'Working site ID',
  fax: 'Fax'
}
